(function () {
  function initStickyBar(bar) {
    var targetId = bar.getAttribute('data-target');
    var target = targetId ? document.getElementById(targetId) : null;

    if (!target || typeof IntersectionObserver === 'undefined') {
      return;
    }

    var show = function () {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    };

    var hide = function () {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    };

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hide();
          } else if (entry.boundingClientRect.top < 0) {
            show();
          } else {
            hide();
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);
  }

  document.querySelectorAll('[data-sticky-bar]').forEach(initStickyBar);
})();
